/*
 * Reform — cart drawer outbound-link guard.
 * The only outbound action allowed from the drawer is Checkout (a <button
 * name="checkout"> / accelerated-checkout web component — not anchors). Every
 * <a href> inside the drawer (empty-state "Continue shopping", cart line-item
 * image/title links) would otherwise navigate to the store's default, non-brand
 * product/catalog pages. We intercept those clicks and close the drawer instead,
 * keeping the shopper in the branded experience. Delegated + idempotent so it
 * survives the drawer re-rendering its markup on every cart change.
 */
(function () {
  if (window.__reformCartDrawerInit) return;
  window.__reformCartDrawerInit = true;

  function closeDrawer() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    if (typeof d.close === 'function') d.close();
    else d.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || !drawer.contains(link)) return;

    // Neutralize the navigation and dismiss the drawer. Checkout is a <button>,
    // so it is never matched here and continues to work normally.
    e.preventDefault();
    closeDrawer();
  }, true);

  // The in-cart subscription upsell that used to live here (POSTing a
  // selling_plan to /cart/change.js) was removed — Reform is one-time purchase
  // only and the product no longer has any selling plans.
})();
